import React from "react";
import ReactDOM from "react-dom";
import "./helpers/axiosInterceptor";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
